import tree from './Tree'

export {
  tree
}



// WEBPACK FOOTER //
// ./src/components/vue-d3-tree/index.js